/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Retry_ButtonInputs */

const en_tasks_retry_button = /** @type {(inputs: Tasks_Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Re-run`)
};

const fr_tasks_retry_button = /** @type {(inputs: Tasks_Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relancer`)
};

const ms_sg2_tasks_retry_button = /** @type {(inputs: Tasks_Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancar semula`)
};

/**
* | output |
* | --- |
* | "Re-run" |
*
* @param {Tasks_Retry_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_retry_button = /** @type {((inputs?: Tasks_Retry_ButtonInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Retry_ButtonInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_retry_button(inputs)
	if (locale === "fr") return fr_tasks_retry_button(inputs)
	return ms_sg2_tasks_retry_button(inputs)
});